import { render, staticRenderFns } from "./UploadKoReport.vue?vue&type=template&id=6f2dfb72"
import script from "./UploadKoReport.vue?vue&type=script&lang=js"
export * from "./UploadKoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports